import { useAuth } from '@/features/auth/hooks/useAuth'

/**
 * ¿Puede el usuario actual usar Comunicaciones? Lo decide el backend (`canManageComms` de
 * `/auth/me`: permiso o ADMIN); aquí solo se lee para mostrar el enlace y la ruta. La API lo
 * impone con la autoridad COMMS.
 */
export function useCanManageComms(): boolean {
  const { user } = useAuth()
  return user?.canManageComms === true
}
